import axios from "src/utils/axios";

export const getMaintenanceStatus = async ({ signal }) => {
  const { data } = await axios.get("/auth/maintenance", { signal });
  return data;
};
const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export const getAllSchoolList = async () => {
  const { data } = await axios("school/list");
  return data.data;
};
export const ordersCourier = async ({ queryKey, signal }) => {
  const [
    _,
    schoolID,
    courierCompanyID,
    riderID,
    packageID,
    status,
    fromDate,
    toDate,
    shippingType,
    years,
  ] = queryKey;

  const params = new URLSearchParams();

  if (courierCompanyID) params.append("courierCompanyID", courierCompanyID);
  if (riderID) params.append("riderID", riderID);
  if (packageID) params.append("packageID", packageID);
  if (status) params.append("status", status);
  if (fromDate) params.append("fromDate", fromDate);
  if (toDate) params.append("toDate", toDate);
  if (shippingType) params.append("shippingType", shippingType);

  // Add multiple years
  if (Array.isArray(years)) {
    years.forEach((year) => params.append("years", year));
  }

  const url = `orders/school/${schoolID}?${params.toString()}`;

  const { data } = await axios.get(url, { signal });
  return data.data;
};

export const ordersSchool = async ({ queryKey, signal }) => {
  const [
    _,
    schoolID,
    years,
    packageID,
    status,
    startDate,
    endDate,
    shippingType,
    addmissionType,
    standardID,
  ] = queryKey;

  const params = new URLSearchParams();

  // Append only if values exist
  if (packageID) params.append("packageID", packageID);
  if (status) params.append("status", status);
  if (startDate) params.append("fromDate", startDate);
  if (endDate) params.append("toDate", endDate);
  if (shippingType) params.append("shippingType", shippingType);
  if (addmissionType) params.append("addmissionType", addmissionType);
  if (standardID) params.append("standardID", standardID);

  years.forEach((year) => params.append("years", year)); // Always append years

  const url = `orders/school/${schoolID}?${params.toString()}`;

  const { data } = await axios.get(url, { signal });
  return data.data;
};
export const ordersList = async ({ queryKey, signal }) => {
  const req = {
    schoolID: queryKey[1],
    packageID: queryKey[2] ? queryKey[2] : undefined,
    status: queryKey[3] === "" ? undefined : queryKey[3],
    fromDate: queryKey[4] ?? undefined,
    toDate: queryKey[5] ?? undefined,
    shippingType: queryKey[6] === "" ? undefined : +queryKey[6],
    year:
      queryKey[7] && queryKey[7].length
        ? queryKey[7].join(",")
        : new Date().getFullYear().toString(),
    addmissionType: queryKey[8] ? +queryKey[8] : undefined,
    standardID: queryKey[9] ? +queryKey[9] : undefined,
  };

  const { data } = await axios.post("orders/list", req, { signal });
  return data.data;
};
export const ordersSingleOrder = async ({ queryKey, signal }) => {
  const { data } = await axios("orders/singleOrder/" + queryKey[1]);
  return data.data;
};
export const masterGetData = async ({ queryKey, signal }) => {
  const [_, tableName, page, limit, where] = queryKey;

  const payload = {
    tableName,
    page: +page + 1,
    limit,
  };

  if (where) {
    payload.where = where;
  }

  const { data } = await axios.post("master/getData", payload, { signal });
  return data?.data[0] || [];
};
export const getInventoryCategories = async ({ queryKey, signal }) => {
  const [_, packageId] = queryKey;
  
  if (!packageId) return [];
  
  const payload = {
    packageId: packageId
  };
  
  const { data } = await axios.post("inventory/categories", payload, { signal });
  return data?.data || [];
};
export const getPackageSet = async ({ queryKey, signal }) => {
  const [_, packageId, categoryID] = queryKey;
  
  if (!packageId || !categoryID) return [];
  
  const payload = {
    packageId: packageId,
    categoryID: categoryID
  };
  
  const { data } = await axios.post("inventory/packageset", payload, { signal });
  return data?.data || [];
};

export const masterGetDataPromoCode = async ({ queryKey, signal }) => {
  const pageIndex = queryKey[2] || 0;
  const pageSize = queryKey[3] || 10;
  const vendorId = queryKey[4] || "";
  const isActive = queryKey[5] !== "" ? queryKey[5] : "";

  const params = {
    page: pageIndex + 1,
    limit: pageSize,
  };

  if (vendorId) params.vendorid = vendorId;
  if (isActive !== "") params.isActive = isActive;

  const { data } = await axios.get("promocode/getcodelist", {
    params,
    signal,
  });

  const promoData = data?.data?.[0]?.data || [];
  const count = data?.data?.[0]?.count || 0;

  return { data: promoData, count };
};
export const masterGetDataByid = async ({ queryKey, signal }) => {
  const { data } = await axios.post(
    "master/getData",
    {
      tableName: queryKey[1],
      page: +queryKey[2] + 1,
      limit: queryKey[3],
      where: [{ field: queryKey[4], operator: "=", value: queryKey[5] }],
    },
    { signal }
  );
  return data?.data[0] || [];
};
export const getOrderSummary = async ({
  schoolID,
  vendorId,
  fromDate,
  toDate,
  years,
  gradeID 
}) => {
  const params = new URLSearchParams();

  if (schoolID) params.append("schoolID", schoolID);
  if (vendorId) params.append("vendorId", vendorId);
  if (fromDate) params.append("fromDate", formatDate(fromDate));
  if (toDate) params.append("toDate", formatDate(toDate));
  if (gradeID) params.append("gradeID", gradeID);  
  years.forEach((year) => params.append("years", year));

  const url = `orders/ordersummary?${params.toString()}`;
  const { data } = await axios.get(url);
  return data.data;
};

export const getVendorsBySchool = async ({ signal, schoolID }) => {
  const url = schoolID
    ? `master/vendorlist?schoolID=${schoolID}`
    : "master/vendorlist";

  const { data } = await axios.get(url, { signal });
  return data.data;
};
export const updateAcceptOrdersData = async ({ id, isActive }) => {
  const { data } = await axios.patch("master/updateAcceptOrdersData", {
    id,
    isActive,
  });
  return data;
};
export const clearCartData = async ({ id }) => {
  const { data } = await axios.patch("master/clearcart", {
    id,
  });
  return data;
};
export const masterBulkCopyPackages = async (payload) => {
  const { data } = await axios.post("master/copypackages", payload);
  return data;
};
export const getProducts = async ({ queryKey, signal }) => {
  const [_, pageIndex,pageSize,search,categoryId] = queryKey;

  const payload = {
    params: {
      page: pageIndex + 1,
      limit: pageSize,
      ...(search ? { search } : {}),
      ...(categoryId && { categoryId }),
    },
    signal,
  };

  try {
    const response = await axios.get(`master/getProduct`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getProductsWithVariations = async ({ queryKey, signal }) => {
  const [_, pageIndex, pageSize] = queryKey;

  const payload = {
    params: {
      page: pageIndex + 1,
      limit: pageSize,
      variation: 1, 
    },
    signal,
  };

  try {
    const response = await axios.get(`master/getProduct`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getProductsWithOutVariations = async ({ queryKey, signal }) => {
  const [_, pageIndex, pageSize] = queryKey;

  const payload = {
    params: {
      page: pageIndex + 1,
      limit: pageSize,
      variation: 0, 
    },
    signal,
  };

  try {
    const response = await axios.get(`master/getProduct`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addProduct = async (productData) => {
  const { data } = await axios.post("/master/addProduct", productData);
  return data;
};
export const saveStudentKit = async ({ signal, req }) => {
  const { data } = await axios.post("master/addSizes", req, { signal });
  return data;
};
export const updateProduct = async (productData) => {
  const { data } = await axios.patch("/master/updateProduct", productData);
  return data;
};
export const getProductVariations = async (productIds) => {
  const { data } = await axios.get(
    `/parent/admin/getvariation?productIds=${productIds}`
  );
  return data;
};
export const updateOrderProductVariation = async (req) => {
  const { data } = await axios.patch(
    "/parent/admin/updateorderproductvariation",
    req
  );
  return data;
};
export const masterSaveData = async ({ signal, req, isEditMode }) => {
  if (isEditMode) {
    const { data } = await axios.patch("master/updateData/", req, { signal });
    return data.data;
  }
  const { data } = await axios.post("master/addData/", req, { signal });
  return data.data;
};
export const updateVariationData = async ({ signal, req }) => {
  const { data } = await axios.patch("master/updateVariationData/", req, {
    signal,
  });
  return data;
};
export const masterSaveVendor = async ({ signal, req, isEditMode }) => {
  if (isEditMode) {
    const { data } = await axios.patch("master/updateData/", req, { signal });
    return data.data;
  }
  const { data } = await axios.post("master/addData/", req, { signal });
  return data.data;
};
export const getVendorDetails = async (vendorId) => {
  const { data } = await axios.get(`master/vendor/get?vendorid=${vendorId}`);
  return data;
};
export const getSchoolDetails = async (schoolId) => {
  const { data } = await axios.get(`orders/groupschoollist/${schoolId}`);
  return data;
};
export const getVendorDetail = async ({ queryKey, signal }) => {
  const [, , pageIndex, pageSize] = queryKey;
  const { data } = await axios.get(
    "master/vendor/get",
    { tableName: "vendor", page: pageIndex + 1, limit: pageSize },
    { signal }
  );
  return data?.data[0];
};
export const savePromoCode = async (data, isEditMode) => {
  const response = await axios.post(
    `promocode/createpromocode?vendorid=${data.vendorid.id}&amount=${data.amount}&numPromoCodes=${data.numPromoCodes}`,
    {}
  );
  return response.data;
};
export const masterDataPackage = async (req) => {
  const { data } = await axios.post("master/getData", req);
  return data.data;
};
export const ordersUpdate = async ({ signal, req }) => {
  const { data } = await axios.patch("orders/update", req, { signal });
  return data.data;
};
export const ordersUpdateCategory = async ({ signal, req }) => {
  const { data } = await axios.patch("orders/updateCategory", req, { signal });
  return data.data;
};
export const orderslabel = async (orderId) => {
  const { data } = await axios.post("orders/label", orderId);
  return data.data;
};
export const masterDeleteData = async ({ signal, req }) => {
  const { data } = await axios.delete(
    "master/deleteData/",
    { data: req },
    { signal }
  );
  if (data.status === "Error") {
    throw new Error(data.message || "Failed to delete record");
  }
  return data.data;
};
export const addressStates = async ({ signal }) => {
  const { data } = await axios(`/address/states`, { signal });
  return data.data;
};
export const studentGetAll = async ({ signal }) => {
  const { data } = await axios(`/master/student/get`, { signal });
  return data.data;
};
export const uploadImage = async (type, req) => {
  const { data } = await axios.post(`/upload/image/${type}`, req, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};
export const runTestReport = async () => {
  const { data } = await axios.post("report/run-test");
  return data;
};
export const getTestReportLinks = async () => {
  const { data } = await axios.get("report/test-report");
  return data?.data || [];
};
export const fetchInventoryData = async (schoolID, standardID) => {
  let url = `report/packageinventorytarget?schoolID=${schoolID}`;
  if (standardID) {
    url += `&standardID=${standardID}`;
  }
  const response = await axios.get(url);
  return response.data.data[0] || [];
};
export const reportNewAndPendingOrder = async (req) => {
  const { data } = await axios(
    `report/newAndPendingOrder/${req.schoolID}/${req.initialDate}/${req.endDate}`
  );
  return data.data;
};
export const reportOrderProductReport = async (req) => {
  const { schoolID, initialDate, endDate } = req;

  const params = new URLSearchParams();
  if (schoolID) params.append("schoolID", schoolID);
  if (initialDate) params.append("initialDate", initialDate);
  if (endDate) params.append("endDate", endDate);

  const url = `report/orderProductReport?${params.toString()}`;
  const { data } = await axios(url);
  return data.data;
};
export const reportNewOrderReport = async (req) => {
  const { data } = await axios(
    `report/newOrderReport/${req.schoolID}/${req.initialDate}/${req.endDate}`
  );
  return data.data;
};
export const reportSchoolWiseProduct = async (req) => {
  const { schoolID, packageID, productID, initialDate, endDate } = req;

  const url = `/orders/schoolpendingprod?schoolID=${schoolID}&packageID=${packageID}&productID=${productID}&initialDate=${initialDate}&endDate=${endDate}`;

  const response = await axios.get(url);
  return response.data.data;
};
export const reportStudentWiseProduct = async (req) => {
  const { schoolID, packageID, productID, initialDate, endDate } = req;

  const params = new URLSearchParams();

  if (schoolID) params.append("schoolID", schoolID);
  if (packageID) params.append("packageID", packageID);
  if (productID) params.append("productID", productID);
  if (initialDate) params.append("initialDate", initialDate);
  if (endDate) params.append("endDate", endDate);

  const url = `report/pendingProduct?${params.toString()}`;

  const response = await axios.get(url);
  return response.data.data;
};
export const reportPendingProduct = async (req) => {
  const { data } = await axios(
    `report/school/pendingProduct/${req.schoolID}/${req.initialDate}/${req.endDate}`
  );
  return data.data;
};
export const addressAdd = async ({ signal, req }) => {
  const { data } = await axios.patch(`address/update`, req, { signal });
  return data.data;
};
export const masterStudentAdd = async ({ signal, req, isEditMode }) => {
  if (isEditMode) {
    const { data } = await axios.post(`master/student/update`, req, { signal });
    return data?.data;
  }
  const { data } = await axios.post(`master/student/add`, req, { signal });
  return data.data;
};
export const invoiceGet = async ({ orderID, vendorId, signal }) => {
  const { data } = await axios(
    `/invoice/admin/get/${orderID}?vendorId=${vendorId}`,
    { signal }
  );
  return data?.data[0] || {};
};
export const ticketsAdminUpdate = async ({ signal, req }) => {
  const { data } = await axios.post(
    `/tickets/admin/update?ticketID=${req.ticketID}&status=${req.status}`,
    { signal }
  );
  return data;
};
export const fetchOrderStatusByMobile = async ({ mobile, signal }) => {
  const { data } = await axios.post(
    "cart/admin/fetchtransaction",
    { mobile },
    { signal }
  );
  return data;
};
export const ArchivalPackages = async ({ signal, fromDate }) => {
  const req = {
    fromDate: formatDate(fromDate),
  };
  const { data } = await axios.post("master/archieveData", {
    data: req,
    signal,
  });
  return data;
};
export const getLastArchivalDate = async () => {
  const { data } = await axios.post("master/archieveDate/get");
  return data?.data?.[0]?.date || null;
};

export const packageConstituents = async (id) => {
  const { data } = await axios(`package/constituents/${id}`);
  return data.data;
};
export const ticketsTicketupdate = async ({ signal, req }) => {
  const { data } = await axios.post("tickets/admin/Ticketupdate", req, {
    signal,
  });
  return data;
};
export const packageAdminList = async ({ queryKey, signal }) => {
  const { data } = await axios("package/admin/list/" + queryKey[1], {
    signal,
  });
  return data.data;
};

export const packageAdminConstituents = async (id) => {
  const { data } = await axios("package/admin/constituents/" + id);
  return data.data;
};
export const cartAdminAdd = async ({ signal, req }) => {
  const { data } = await axios.post("cart/admin/add", req, { signal });
  return data;
};
export const deliveryGetRider = async ({ signal, req }) => {
  const { data } = await axios("delivery/getRider", req, { signal });
  return data;
};
export const CourierOrdersList = async ({ queryKey, signal }) => {
  const req = {
    courierCompanyID: queryKey[1],
    riderID: queryKey[2] === "" ? undefined : +queryKey[2],
    schoolID: queryKey[3] === "" ? undefined : +queryKey[3],
    packageID: queryKey[4] === "" ? undefined : +queryKey[4],
    status: queryKey[5] === "" ? undefined : queryKey[5],
    fromDate: queryKey[6] ?? undefined,
    toDate: queryKey[7] ?? undefined,
    shippingType: queryKey[8] === "" ? undefined : +queryKey[8],
    year:
      queryKey[9] && queryKey[9].length
        ? queryKey[9].join(",")
        : new Date().getFullYear().toString(),
  };
  const { data } = await axios.post("orders/filterList", req, { signal });
  return data.data;
};

export const getInventory = async ({ queryKey, signal }) => {
  const [_key, search] = queryKey;

  const url = search
    ? `inventory/get?search=${encodeURIComponent(search)}`
    : `inventory/get`;

  const { data } = await axios.get(url, { signal });
  return data;
};

export const getAllDraftPurchaseByStatus = async ({ queryKey, signal }) => {
  const [, orderStatus] = queryKey;
  const req = {
    // schoolID,
    orderStatus,
  };
  const { data } = await axios.post("orders/getDraft", req, { signal });
  return data;
};
export const getAllDraftByStatus = async ({ queryKey, signal }) => {
  const [, schoolID, orderStatus] = queryKey;
  const req = { 
    schoolID,
  };
  
  if (orderStatus) {
    req.orderStatus = orderStatus;
  }
  
  const { data } = await axios.post("orders/getDraft", req, { signal });
  return data;
};

export const sendDraftEmail = async (emailData) => {
  const { data } = await axios.post( "/orders/sendEmail", emailData );
  return data;
};

export const addUpdateDraftOrder = async ({ signal, req }) => {
  if (req.purchaseOrderID) {
    const { data } = await axios.post("orders/updateorderDraft", req, { signal });
    return data;
  }
  const { data } = await axios.post("orders/addDraft", req, { signal });
  return data;
};
export const getAllPartyOrder = async ({ signal }) => {
  const { data } = await axios.post("party_master/PartyOrderlist");
  return data;
};
export const addPartyOrder = async ({ signal, req }) => {
  const { data } = await axios.post("party_master/order", req, { signal });
  return data;
};

export const updateInventory = async ({ signal, req }) => {
  const { data } = await axios.post("inventory/add", req, { signal });
  return data.data;
};
export const addProductInventory = async ({ req, signal }) => {
  const { data } = await axios.post("inventory/addProductInventory", req, {
    signal,
  });
  return data.data;
};

export const getAuditData = async ({ signal }) => {
  const { data } = await axios.get("report/login-audit", { signal });
  return data.data;
};

export const uploadPromotionOrderProduct = async (payload) => {
  const { data } = await axios.post("upload/promotionorderproduct", payload);
  return data;
};

export const uploadOrderStatusUpdate = async (payload) => {
  const { data } = await axios.post("upload/orderStatusUpdate", payload);
  return data;
};

export const uploadSelectedOrderCsv = async (payload) => {
  const { data } = await axios.post("upload/selectedordercsv", payload, {
    responseType: "blob",
  });
  return data;
};